import { useState } from "react";
import { DefaultDropdown } from "./Dropdown"
import { Button } from "../Button";

export const Filter = (props) => {
    // listFilters = [ {name: <name>, options: [{label, value}, ...] }, value: <value>, ... ]
    const {
        className,
        listFilters,
        handleChange,
        buttonLabel,
        withLabel,
    } = props;

    const [visible, setVisible] = useState(false);

    return (
        <div className="flex">
            <Button
                id="Filters"
                name={buttonLabel || "Filtre"}
                action={(e) => setVisible(!visible)}
                title="Editer les filtres"
            />
            {withLabel === true &&
                <div className="ml-2 flex gap-2">
                    {
                    listFilters.map((f) => (
                        <div key={f.label} className={(f.options.findIndex((opt) => opt.value == f.value) > 0 ? "flex" : "hidden") + " text-xxs lg:text-xs p-2 m-auto bg-gray-100 text-gray-600 border rounded-xl"}><span className="hidden lg:inline">{f.label}&nbsp;:&nbsp;</span>{f.options.find((opt) => opt.value == f.value).label}</div>
                    ))
                    }
                </div>
            }
            {visible &&
                <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50" onClick={() => setVisible(false)}>
                    <div className="bg-white lg:rounded-2xl shadow-lg w-full lg:max-w-md h-full lg:h-auto p-6 h-max-content overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                        <div className={className || "flex flex-col"} >
                            {
                                listFilters.map((f) => (
                                    <DefaultDropdown
                                        key={f.name}
                                        name={f.label}
                                        className={f.className || "grow shrink"}
                                        options={[...f.options.map(s => ({ label: s.label, value: s.value }))]}
                                        value={f.value}
                                        onChange={(e) => handleChange(f.name, e.target.value)}
                                    />
                                ))
                            }

                        </div >
                        <div className="flex justify-end">
                            <Button
                                id="Close"
                                name={"Fermer"}
                                action={() => setVisible(false)}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}